
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kredit-furnitur",
      function () {
        return require("private-next-pages/kredit-furnitur.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kredit-furnitur"])
      });
    }
  